import {Component, OnDestroy} from '@angular/core';
import {Subscription} from "rxjs";
import {GlobalDateService} from "../../../../../../_services/global-date.service";
import {Router} from "@angular/router";
import {AppRoutes} from "../../../../../../enums/routes";
import {TimeSeriesPerformanceStoreService} from "../../../store/time-series-performance-store.service";
import {EventTableStore} from "../../../store/table/event-table-store";
import {RevenueCalculationStrategy} from "../../../../common/enums/strategies/revenue-calculation-strategy";
import {EventRow} from "./models/event-row";
import {CombinedOrderElementDto} from "../../../models/core/combined-order-element-dto";
import {FilterVO} from "../../../../common/utils/filter/models/filter-vo";
import {FilterKeys} from "../../../../common/utils/filter/enums/filter-keys";
import {MonthRow} from "./models/month-row";
import {RevenueCalculationMethod} from "../../../utils/revenue-calculation-method";
import {AnalyticsRouting} from "../../../../common/routes/analytics-routing";
import {GlobalDateFormat} from "../../../../../../enums/global-date-format";
import {ErrorCodes} from "../../../../common/enums/states/error-codes";
import {CommonModule, CurrencyPipe, DatePipe} from "@angular/common";
import {ErrorMessageComponent} from "../../../../common/components/error-message/error-message.component";
import {FormsModule} from "@angular/forms";

@Component({
  selector: 'analytics-event-overview-table',
  templateUrl: './event-overview-table.component.html',
  styleUrls: ['./event-overview-table.component.css'],
  imports: [
    CommonModule,
    CurrencyPipe,
    DatePipe,
    ErrorMessageComponent,
    FormsModule
  ],
  providers: [EventTableStore]
})
export class EventOverviewTableComponent implements OnDestroy {
  subscription: Subscription = new Subscription();
  locationRevenue: { [key: string]: { id: string, name: string, revenue: number }[] } = {};
  paymentMethodRevenue: { [key: string]: { id: string, name: string, revenue: number }[] } = {};

  displayedMonths: string[] = [];
  protected readonly GlobalDateFormat = GlobalDateFormat;
  protected readonly ErrorCodes = ErrorCodes;

  constructor(public timeSeriesPerformanceStore: TimeSeriesPerformanceStoreService,
              public globalDateService: GlobalDateService,
              private router: Router,
              public eventTableStore: EventTableStore
  ) {
    this.subscribeToStore()
  }

  subscribeToStore() {
    this.subscription.add(this.eventTableStore.updateNotifier.subscribe(data => {
        this.update()
      }
    ));
  }

  toggleInactive(event: boolean, eventRow: EventRow<CombinedOrderElementDto>) {
    eventRow.isActive = event;
    let filter = new FilterVO(FilterKeys.EventId, eventRow.eventDto.id)
    if (!eventRow.isActive) {
      this.timeSeriesPerformanceStore.addFilter(filter);
      this.timeSeriesPerformanceStore.removeEmployeeCosts(filter)
    } else {
      this.timeSeriesPerformanceStore.removeFilter(filter);
      this.timeSeriesPerformanceStore.addEmployeeCosts(filter)
    }
  }

  toggleMonthTab(monthRow: MonthRow<CombinedOrderElementDto>) {
    monthRow.isOpen = !monthRow.isOpen;
  }

  asIsOrder(a: any, b: any) {
    return -1;
  }

  update() {

    this.locationRevenue = {};
    this.paymentMethodRevenue = {};
    this.findAllDisplayedMonths()
  }

  findAllDisplayedMonths() {
    this.displayedMonths = []

    for (let monthRow of this.eventTableStore.revenuePerMonthTableData.values()) {

      if (monthRow.eventEntries.length > 0)
        this.displayedMonths.push(monthRow.name)
    }
  }

  getKeys(map: Map<string, MonthRow<CombinedOrderElementDto>>) {
    // invert the array
    return Array.from(map.values()).reverse();
  }

  getMonthRevenue(monthRow: MonthRow<CombinedOrderElementDto>): number {
    return monthRow.monthRevenue;
  }

  isBorderEvent(eventName: string): number {
    // 0 no border 1 top 2 bottom 3 top and bottom
    let index = this.displayedMonths.indexOf(eventName);

    if (this.displayedMonths.length == 1) {
      return 3;
    }
    if (index == 0) {
      return 1;
    }
    if (index == this.displayedMonths.length - 1) {
      return 2;
    }
    return 0;
  }

  isMonthTabOpen(monthRow: MonthRow<CombinedOrderElementDto>): boolean {
    return monthRow.isOpen;
  }

  monthTabTrackBy(index: number, item: MonthRow<CombinedOrderElementDto>): MonthRow<CombinedOrderElementDto> {
    return item;
  }

  /*revenuePerLocation(eventRow: EventRow<CombinedOrderElementDto>){
    this.calculateRevenuePerLocation(eventRow);
    return this.locationRevenue[eventRow.eventDto.id].reduce((acc, curr) => acc + curr.revenue, 0);
  }*/

  //; trackBy:monthTabTrackBy
  getListOfEvents(monthRow: MonthRow<CombinedOrderElementDto>): EventRow<CombinedOrderElementDto>[] {
    return monthRow.eventEntries
  }

  getEventRevenue(eventRow: EventRow<CombinedOrderElementDto>): number {
    return eventRow.displayedRevenue;
  }

  calculateRevenuePerLocation(eventRow: EventRow<CombinedOrderElementDto>) {
    if (this.locationRevenue[eventRow.eventDto.id] == undefined) {
      this.locationRevenue[eventRow.eventDto.id] = this.eventTableStore.calculateRevenueOfEventRow(eventRow, "locationId");
    }
  }

  hasRevenuePerLocation(eventRow: EventRow<CombinedOrderElementDto>) {
    this.calculateRevenuePerLocation(eventRow);
    return this.locationRevenue[eventRow.eventDto.id].length > 0;
  }

  /*revenuePerPaymentMethod(eventRow: EventRow<CombinedOrderElementDto>){
    this.calculateRevenuePerPaymentMethod(eventRow);
    return this.paymentMethodRevenue[eventRow.eventDto.id].reduce((acc, curr) => acc + curr.revenue, 0);
  }*/

  hasRevenuePerPaymentMethod(eventRow: EventRow<CombinedOrderElementDto>) {
    this.calculateRevenuePerPaymentMethod(eventRow);
    return this.paymentMethodRevenue[eventRow.eventDto.id].length > 0;
  }

  calculateRevenuePerPaymentMethod(eventRow: EventRow<CombinedOrderElementDto>) {
    if (this.paymentMethodRevenue[eventRow.eventDto.id] == undefined) {
      this.paymentMethodRevenue[eventRow.eventDto.id] = this.eventTableStore.calculateRevenueOfEventRow(eventRow, "bookingType");
    }
  }

  getRevenuePerLocation(eventRow: EventRow<CombinedOrderElementDto>): { id: string, name: string, revenue: number }[] {
    this.calculateRevenuePerLocation(eventRow)
    return this.locationRevenue[eventRow.eventDto.id];
  }

  getRevenuePerPaymentMethod(eventRow: EventRow<CombinedOrderElementDto>): {
    id: string,
    name: string,
    revenue: number
  }[] {
    this.calculateRevenuePerPaymentMethod(eventRow);
    return this.paymentMethodRevenue[eventRow.eventDto.id];
  }

  openInNewTab(eventRow: EventRow<CombinedOrderElementDto>) {
    // Todo fix routing
    const url = this.router.serializeUrl(this.router.createUrlTree([AppRoutes.Analytics, {outlets: {analytics: [AnalyticsRouting.DetailedEventAnalysis]}}], {
      queryParams: {eventId: eventRow.eventDto.id},
      relativeTo: undefined
    }));
    window.open(url, '_blank');
  }

  isRevenueBreakdownVisible(eventRow: EventRow<CombinedOrderElementDto>) {
    eventRow.revenue = this.eventTableStore.calculateRevenueOfCombinedOrderElementList(eventRow.orders, RevenueCalculationMethod.fnMapping[RevenueCalculationStrategy.revenue]);
    eventRow.netRevenue = this.eventTableStore.calculateRevenueOfCombinedOrderElementList(eventRow.orders, RevenueCalculationMethod.fnMapping[RevenueCalculationStrategy.revenueExcludingTaxes]);
    return eventRow.isActive
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
